import { defaultHttpClient } from '../../httpClient';
import type { GoodsReviewsMetadataResponse } from './types';

/**
 * - 상품 리뷰 메타데이터 조회 API
 */
export const getGoodsReviewsMetadata = (goodsSno: number) => {
  return defaultHttpClient
    .request<GoodsReviewsMetadataResponse>({
      method: 'GET',
      url: `/webview/goods/${goodsSno}/reviews/metadata/`,
    })
    .then(result => result.data);
};